import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDueSalesVoucherApi } from "../../../apiservice/accounts";
import { getAccountBySeachApi } from "../../../apiservice/setting";

export const fetchCustomerDueReport = createAsyncThunk(
  "customerDueReport/fetch",
  async ({ customerId }, { rejectWithValue, getState }) => {
    try {
      const response = await getDueSalesVoucherApi({ customerId });
      return response.data;
    } catch (err) {
      if (err.response?.status === 401) {
        sessionStorage.clear();
        window.location.reload();
      }
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch customer due report"
      );
    }
  }
);

export const searchCustomers = createAsyncThunk(
  "customerDueReport/searchCustomers",
  async ({ query }, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const { auth: authInfo } = state;
 
      let accountTypes = ["Customer"];
      if (authInfo.subscription === "SuperERP" || authInfo?.auth_info?.branch_company_type === "Pharmacy") {
        accountTypes = ["Customer", "Patient"];
      }

      const response = await getAccountBySeachApi({
        query: query.trim(),
        type: "debitor",
        acc_type_name: accountTypes
      });

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to search customers"
      );
    }
  }
);

const initialState = {
  report: [],
  accounts: [],
  selectedAccount: null,
  loading: false,
  searchLoading: false,
  error: null
};

const customerDueSlice = createSlice({
  name: "customerDueReport",
  initialState,
  reducers: {
    setSelectedAccount: (state, action) => {
      state.selectedAccount = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    resetReport: (state) => {
      state.report = [];
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch report
      .addCase(fetchCustomerDueReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerDueReport.fulfilled, (state, action) => {
        state.loading = false;
        state.report = action.payload;
      })
      .addCase(fetchCustomerDueReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Search customers
      .addCase(searchCustomers.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(searchCustomers.fulfilled, (state, action) => {
        state.searchLoading = false;
        state.accounts = action.payload;
      })
      .addCase(searchCustomers.rejected, (state, action) => {
        state.searchLoading = false;
        state.error = action.payload;
      });
  }
});

export const { setSelectedAccount, clearError, resetReport } = customerDueSlice.actions;
export default customerDueSlice.reducer;